import { useSpring } from '@react-spring/web';
export default () => {
    const [styles, api] = useSpring(() => ({
        scale: 1,
    }));
    const onMouseLeave = () => {
        api.start({ scale: 1 });
    };
    const onMouseEnter = () => {
        api.start({ scale: 0.95 });
    };
    const onPointerDown = () => {
        api.start({ scale: 0.9 });
    };
    const onPointerUp = () => {
        api.start({ scale: 1 });
    };
    return {
        styles,
        bind: () => {
            return {
                onPointerDown,
                onMouseLeave,
                onMouseEnter,
                onPointerUp,
            };
        },
    };
};
